import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import SearchInterface from '../components/search/search_interface';
import MoreStoriesButton from '../components/common/more_stories_button';
import {get} from 'lodash';

const options = {
  displayName: 'SearchContainer',

  contentAboveModules() {
    return (
      <SearchInterface
        fetchStatus={this.props.api.fetchStatus}
        resultsCount={this.props.analytics.result_count}
        searchTerm={this.props.api.searchTerm}
        recordSearchTerm={this.props.recordSearchTerm}
      />
    );
  },

  contentBelowModules() {
    if (!get(this.props, 'api.pagination.next')) {
      return null;
    }
    return (
      <MoreStoriesButton
        api={this.props.api}
        fetchFoundryResponse={this.props.fetchFoundryResponse}
      />
    );
  },

  shouldDisplayError() {
    return false;
  },

  shouldDisplayHeaderAd() {
    return true;
  }
};

export const SearchContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
